// extracted by mini-css-extract-plugin
export default {"body":"DirectAnswerFeedbackModal-module__body--bdec8","footer":"DirectAnswerFeedbackModal-module__footer--e5550 Modals-module__footer--e47b9"};